import { useState, useEffect } from 'react'
import { apiClient } from '@/services/apiClient'

export interface Branding {
  siteName: string
  logoUrl: string
  faviconUrl?: string
  logoUrlsByLang?: Record<string, string>
}

/**
 * Fetches site branding (logo per language, site name) from the public API.
 * Returns logoUrl resolved for the given language.
 */
export function useBranding(lang: string): {
  branding: Branding | null
  logoUrl: string
  siteName: string
  isLoading: boolean
} {
  const [branding, setBranding] = useState<Branding | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    apiClient
      .get<Branding>('/settings/branding')
      .then((res) => {
        if (!cancelled) setBranding(res.data)
      })
      .catch(() => {
        if (!cancelled) setBranding(null)
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false)
      })
    return () => { cancelled = true }
  }, [])

  const langKey = (lang || 'ar').toLowerCase()
  const logoUrlsByLang = branding?.logoUrlsByLang ?? {}
  const logoUrl =
    (logoUrlsByLang[langKey] && logoUrlsByLang[langKey].trim()) ||
    branding?.logoUrl ||
    '/assets/logo.png'
  const siteName = branding?.siteName ?? 'سكينة'

  return {
    branding,
    logoUrl,
    siteName,
    isLoading,
  }
}
